import styled from 'styled-components';
import { device } from 'constants/index';

const Wrapper = styled.div`
  & .inputError {
    margin-top: 10px;
    margin-left: 20px;
    color: #FF6056;
    font-family: "Dexa Pro";
    font-size: 10px;
    font-style: italic;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 1px;
  }
  height: 67px;
  @media ${device.md} {
    width: 100%;
    height: 87px;
     & .inputError {
      margin-top: 5px;
    }
  }
`;

const Input = styled.input`
  width: 100%;
  height: 42px;
  padding: 27px 20px;
  border-radius: 8px;

  color: #F1F1F1;
  font-size: 18px;
  font-weight: 300;
  border-bottom: 1px solid  #464545;

  &::placeholder {
    color: #D9D9D9;
    font-size: 18px;
    font-weight: 400;
    opacity: 1;
  }

  &:focus-visible {
    border: none;
    border-bottom: 1px solid  #4069ed;
    outline:none;
  }
  @media ${device.md} {
    height: 65px;
  }
`;

export default { Wrapper, Input };
